import {Tile as TileLayer} from 'ol/layer.js';
import TileWMS from 'ol/source/TileWMS.js';
import {Layer} from './Layer.js';
import {getMapLayers} from './config.js';

export class MapLayer extends Layer {
    url = "/cgi-bin/mapserver/basic";
    type = "basic";
    map_layers = [];
    styles = [];
    style = "dark";

    constructor(map, settings = {}){
        let type;
        if( settings.type ){ type = settings['name'] = settings.type; delete settings.type; }
        super( map, settings );
        if( type ) this.type = type;
        this.class = "wms";
        this.getState();

        this.url = this.map.server + "/cgi-bin/mapserver/basic";

        this.map_layers = getMapLayers( this.type );
        this.styles = Array(this.map_layers.length).fill(this.style);

        if( this.settings['visible'] ) this.settings['visible'] = true;
        this.layer = new TileLayer({
            "source": new TileWMS({
                "url": this.url,
                "params": {
                    'LAYERS': this.map_layers, 
                    'STYLES': this.styles, 
                    'TILED': true
                    },
                "serverType": 'mapserver'
            }),
            "visible": this.settings['visible']
        });
    }

    setStyle(type){
        this.style = type;
        console.info( this.name, this.style );
        this.styles = Array(this.map_layers.length).fill(this.style);
        this.layer.getSource().updateParams({'STYLES': this.styles});
        this.layer.getSource().refresh();
        return 1;
    }
}
